<template lang="pug">
  div
    Row
      Col(:lg="24" :md="24")
        Card.dashBoardCard
          LineChartWrapper(
              :chartType="'reqlinechart'"
              :chartDataSetLabel="[$t('dashboard.requestCount')]"
              :titleDisplay="false"
              :numeralFormatTooltips="'0.00a'"
              :numeralFormatYAxes="'0a'"
              :withCard="false"
              :chartHeight="chartHeight"
              :linePointRadius="[4]"
              :linePointHoverRadius="[8]"
              :linePointBackgroundColor="['white']"
              :linePointBorderWidth="[3]"
              :lineBorderColors="[colorScheme.blue.border]"
              :linePointHoverBorderWidth="[5]"
              :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)']"
              :linePointHoverBackgroundColor="['white']"
              :lineBackgroundGradientStops="[colorScheme.blue.gradientStops]"
              :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
          SingleNumWrapper(
            :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
            :chartType="'reqsumnum'"
            :chartTitle="$t('dashboard.totalRequestCount')"
            :numeralFormat="'0.00a'"
            :withCard="false"
            :textInSingleLine="true"
            maxFontSize="26px"
            style="text-align: right;"
          )
          SingleNumWrapper(
            :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
            :chartType="'reqRateNum'"
            :chartTitle="$t('dashboard.avgRequestSpeedRate')"
            :numStringSuffix="' / s'"
            :withCard="false"
            :textInSingleLine="true"
            maxFontSize="26px"
            style="text-align: right;"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
          )
    Row
      Col(:lg="8" :md="12")
        Card.dashBoardCard
          PieChartWrapper(
              :chartType="'sourceIpPieChart'"
              :chartTitle="$t('dashboard.visitorIp')"
              :topNSize="5"
              :chartHeight="chartHeight"
              :withCard="false"
              
              :pieBackgroundColors="[colorScheme.colorSets.fill]"
              :legendPosition="'right'"
              :legendAlign="'start'"
              :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
              )
      Col(:lg="16" :md="12")
        Card.dashBoardCard
          BarChartWrapper(
            :chartType="'servicegroupbarchart'"
            :chartDataSetLabel="[$t('dashboard.serviceGroupNameText')]"
            :topNSize="3"
            :chartHeight="chartHeight"
            :withCard="false"
            
            :direction="direction"
            :barBorderColors="[colorScheme.blue.border]"
            :barBackgroundColors="[colorScheme.blue.fill]"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
    Row
      Col(:lg="8" :md="12")
        Card.dashBoardCard
          PieChartWrapper(
              :chartType="'countryPieChart'"
              :chartTitle="$t('dashboard.countryText')"
              :topNSize="5"
              :chartHeight="chartHeight"
              :withCard="false"
              
              :pieBackgroundColors="[colorScheme.colorSets.fill]"
              :legendPosition="'right'"
              :legendAlign="'start'"
              :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
              )
      Col(:lg="16" :md="12")
        Card.dashBoardCard
          BarChartWrapper(
              :chartType="'domainbarchart'"
              :chartDataSetLabel="[$t('dashboard.domainNameText')]"
              :topNSize="10"
              :chartHeight="chartHeight"
              :withCard="false" 
              :direction="direction"
              :barBorderColors="[colorScheme.blue.border]"
              :barBackgroundColors="[colorScheme.blue.fill]"
              :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
              )
    Row
      Col(:lg="8" :md="12")
        Card.dashBoardCard
          BarChartWrapper(
              :chartType="'sourceipbarchart'"
              :chartDataSetLabel="[$t('dashboard.visitorIp')]"
              :topNSize="10"
              :chartHeight="chartHeight"
              :withCard="false"
              :direction="direction"
              :barBorderColors="[colorScheme.blue.border]"
              :barBackgroundColors="[colorScheme.blue.fill]"
              :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
              )
      Col(:lg="16" :md="12")
        Card.dashBoardCard
          BarChartWrapper(
              :chartType="'uribarchart'"
              :chartDataSetLabel="[$t('dashboard.uri')]"
              :topNSize="10"
              :chartHeight="chartHeight"
              :withCard="false"
              :direction="direction"
              :barBorderColors="[colorScheme.blue.border]"
              :barBackgroundColors="[colorScheme.blue.fill]"
              :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
              )
    Row
      Col(:lg="24" :md="24")
        Card.dashBoardCard
          BarChartWrapper(
            :chartType="'userAgentBarChart'"
            :chartDataSetLabel="[$t('dashboard.userAgent')]"
            :topNSize="10"
            :chartHeight="chartHeight"
            :withCard="false"
            :direction="direction"
            :barBorderColors="[colorScheme.blue.border]"
            :barBackgroundColors="[colorScheme.blue.fill]"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )

</template>
<script>
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import BarChartWrapper from "@/components/dashboard/BarChartWrapper";
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import PieChartWrapper from "@/components/dashboard/PieChartWrapper";

import colorScheme from "@/data/colorScheme";

export default {
    components: {
        LineChartWrapper,
        BarChartWrapper,
        SingleNumWrapper,
        PieChartWrapper
    },
    props: {
        groupNames: {
            type: Array,
            default: () => []
        },
        serviceGroupNames: {
            type: Array,
            default: () => []
        },
        domains: {
            type: Array,
            default: () => []
        },
        origins: {
            type: Array,
            default: () => []
        },
        edgeNames: {
            type: Array,
            default: () => []
        },
        dateRange: {
            type: String,
            default: "1"
        },
        customTimeRange: {
            type: Array,
            default: () => ["", ""]
        },
        direction: {
            type: String,
            default: "vertical"
        }
    },
    data() {
        return {
            colorScheme: colorScheme,
            chartHeight: 280
        };
    },
    computed: {
        showRawBtnStyle() {
            return this.$store.getters.getChartConfig.showRawBtnStyle;
        }
    }
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/HomePage/OverviewContent.vue